module.exports = __webpack_public_path__ + "static/media/chromadrum.8dd47623.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/chromadrum.png
 ** module id = 287
 ** module chunks = 0
 **/